import type { ButtonProps } from '../Buttons/Button';

export const AlertVariant = {
  Info: 'info',
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
  InfoGray: 'infoGray',
  InfoDark: 'infoDark',
  Transparent: 'transparent',
} as const;

export type AlertAction = {
  label: string;
  onClick?(): void;
  href?: string;
  /** Button style for a non-link action. Defaults to the Button's own default (contained/primary). */
  variant?: ButtonProps['variant'];
};

export const isAlertAction = (action: unknown): action is AlertAction =>
  action !== null && typeof action === 'object' && 'label' in action && typeof action.label === 'string';
